import React, { Component } from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'
import numeral from 'numeral'
import moment from 'moment';

import { toast } from 'react-toastify'

import Box from '../components/Layout/Box'
import BoxButton from '../components/Layout/BoxButton'
import ButtonStrip from '../components/Layout/ButtonStrip'
import BoxSection from '../components/Layout/BoxSection'
import SelectorInput from '../components/Shared/SelectorInput'
import ModalSelectorFromList from '../components/Shared/ModalSelectorFromList'
import ModalAddServicio from '../components/CreacionSolicitudServicioOT/ModalAddServicio'
import AttachedFilesBox from '../components/Shared/AttachedFilesBox'
import ModalAddFile from '../components/Shared/ModalAddFile'

import { formatcoin, getDivisa } from '../utils/helpers'

import { showModalSelector, selectFromSelector, getParameterByName } from '../actions/common'
import {
    updateInputs,
    displayModalAddServicio,
    removeSolicitudServicioItems,
    toggleSelectAllSolicitudServicioItems,
    displayModalAddFile,
    toggleSelectAllSolicitudServicioFiles,
    uploadFile,
    removeSolicitudServicioFiles,
    createSolicitudServicio,
    removeSolicitudServicioResponsable,
    addResponsable,
    addCencoSolicitudServicio,
    removeCencosSolicitudServicio,
    addUsuarioResponsable,
    initReducer,
    addSolicitudServicioFile,
    enviarComentario,
    editarComentario,
    eliminarComentario
} from '../actions/creacionsolicitudservicioot'

class CreacionSolicitudServicioOT extends Component {

    componentWillMount() {
        this.props.initReducer()
        this.props.getParameterByName('DIVISAS')
    }

    handleOpenSelector = (path) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'fullname', width: '70%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT', payload)
        }
        this.props.showModalSelector('Listado de usuarios', columns, '/usuarios/cencos', fn)
    }


    handleOpenSelectorAddCenco = (list) => {

        let columns = [
            { id: 1, caption: 'Codigo', value: 'codigo', width: '30%' },
            { id: 2, caption: 'Descripcion', value: 'descripcion', width: '70%' }   
		]

        const payload = {}

        const fn = (a) => {
            const index = this.props.creacionsolicitudservicioot.get('cencos').findIndex(c => c.getIn(['cenco', 'id']) == a.id)
            if (index >= 0) {
                toast.warn(`El cenco ${a.codigo} ya se encuentra en el listado`, { bodyClassName: 'toastify-content toastify-warning' })
            } else {
                payload.path = list
                payload.value = a
                this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT', payload)
            }
        }
        const customFilter = { column: 'T0.responsable_id', operator: '===', value: this.props.creacionsolicitudservicioot.getIn(['ordenador_gasto', 'id']), comparison: 'string' }
        this.props.showModalSelector('Listado de centros de costo', columns, '/cencos', fn, customFilter)
	}

    handleOpenSelectorAddResponsable = (path) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'fullname', width: '70%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector(() => this.props.addResponsable(payload))
        }
        this.props.showModalSelector('Listado de usuarios', columns, '/usuarios/ldap', fn)
    }

    handleOpenSelectorProveedor = (path) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'identificacion', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'nombre', width: '70%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_SERVICIO_OT', payload)
        }
        this.props.showModalSelector('Listado de proveedores', columns, '/proveedores', fn)
    }

    handleOpenSelectorMoneda = (moneda) => {
        this.props.updateInputs('moneda',moneda)
    }

	render() {
        const { creacionsolicitudservicioot, enums, divisas } = this.props

        const moneda = creacionsolicitudservicioot.get('moneda')
        const divisa = getDivisa(divisas, moneda)
        
        const boxActions = [
            <BoxButton key="ba[0][1]" name="floppy-o" onClick={ () => this.props.createSolicitudServicio() } title="Guardar" disabled={ creacionsolicitudservicioot.get('btnSaveDisabled') } />
        ]

        const actionsSectionDetallesServicios = [
            <BoxButton key="ba[1][0]" size={14} contrast name="plus-circle" onClick={ e => this.props.displayModalAddServicio(true, 'Agregar Item', 'create') } title="Adicionar servicio"/>,
            <BoxButton key="ba[1][1]" size={14} contrast name="trash" onClick={ e => this.props.removeSolicitudServicioItems() } title="Eliminar servicio" danger disabled={ creacionsolicitudservicioot.get('servicios').filter(x => x.get('selected')).count() === 0 }/>
        ]

		const actionsDistribucionCencos = [
            <BoxButton key="ba[4][0]" size={14} name="plus-circle" onClick={ e => this.props.addCencoSolicitudServicio() } title="Nueva" />,
            <BoxButton key="ba[4][1]" size={14} name="trash" onClick={ e => this.props.removeCencosSolicitudServicio() } title="Eliminar" disabled={ creacionsolicitudservicioot.get('cencos').filter(x => x.get('selected')).count() === 0 } danger/>,
		]

        const actionsAdicionarResponsable = (path) => {
            return [
                <BoxButton key={`ba[${path}][0]`} size={14} name="plus-circle" onClick={ () => this.props.addUsuarioResponsable(path) } title="Adicionar"/>,
                <BoxButton key={`ba[${path}][1]`} size={14} name="trash" onClick={ () => this.props.removeSolicitudServicioResponsable(path) } title="Eliminar" disabled={ creacionsolicitudservicioot.get(path).filter(x => x.get('selected')).count() === 0 } />
            ]
        }

        const totalSevicios_sin_iva = creacionsolicitudservicioot.get('servicios').map(x => Number(x.get('cotizado'))).reduce((a, b) => { b += a; return b }, 0)

        const totalSevicios = creacionsolicitudservicioot.get('servicios').map(x => Number(x.get('cotizado_iva'))).reduce((a, b) => { b += a; return b }, 0)


		return (
            <div className="row" style={{ height: '100%', overflowX: 'hidden' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <Box title="Solicitud de servicios - Oficina técnica > Creación de solicitud">
                        <ButtonStrip actions={ boxActions } />
                        <div className="box-content">
                            <div>
                                <BoxSection title="Información básica">
                                <div className="row">

                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className="control-label">Solicitante</label>
                                                <input type="text" value={this.props.user.get('fullname') || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Correo</label>
                                                <input type="text" value={this.props.user.get('email') || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>


                                        <div className="col-md-1">
                                            <div className="form-group">
                                                <label className="control-label">Extensión</label>
                                                <input type="text" value={this.props.user.get('extension') || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>


                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Área</label>
                                                <input type="text" value={this.props.user.getIn(['area', 'nombre']) || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>

                                    </div>


                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className="control-label">Responsable de compras</label>
                                                <input className="form-control input-sm" type="text" value={enums.solicitudes.tipos[creacionsolicitudservicioot.get('tipo')].responsable.fullname || ''} disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Correo</label>
                                                <input className="form-control input-sm" value={enums.solicitudes.tipos[creacionsolicitudservicioot.get('tipo')].responsable.email || ''} disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-1">
                                            <div className="form-group">
                                                <label className="control-label">Extensión</label>
                                                <input className="form-control input-sm" type="text" value={enums.solicitudes.tipos[creacionsolicitudservicioot.get('tipo')].responsable.extension || ''} disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label className="control-label">Fecha de solicitud</label>
                                                <input className="form-control input-sm" value={moment().format('YYYY/MM/DD')} disabled />
                                            </div>
                                        </div>

                                    </div>

                                </BoxSection>


                                <div className="separator"></div>



                                <BoxSection title="Información del servicio">
                                    <div className="row">
                                        <div className="col-md-7">
                                            <div className="form-group">
                                                <label className="control-label">Proyecto/Evento/Actividad</label>
                                                <input type="text" value={ creacionsolicitudservicioot.get('proyecto_evento') } className="form-control input-sm" onChange={ e => this.props.updateInputs('proyecto_evento', e.target.value) }/>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Proveedor</label>
                                                <SelectorInput value={ creacionsolicitudservicioot.getIn(['proveedor', 'nombre']) || '' } onClick={ () => this.handleOpenSelectorProveedor('proveedor') } onReset={ () => this.props.updateInputs('proveedor', null) } />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label className="control-label">Fecha de entrega</label>
                                                <input type="date" value={ creacionsolicitudservicioot.get('fecha_requerido') || '' } className="form-control input-sm" onChange={ e => this.props.updateInputs('fecha_requerido', e.target.value) }/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <Box title={ `Responsables del ingreso del proveedor` } actions={ actionsAdicionarResponsable('responsable_ingreso') } onModal>
                                                <div className="box-content" style={{ height: '81px', overflowX: 'hidden' }}>
                                                    <table className="table table-condensed">
                                                        <tbody>
                                                            {
                                                                creacionsolicitudservicioot.get('responsable_ingreso').map((a, b) => {
                                                                    return (
                                                                        <tr key={ `tr3[${a.get('id')}]` } className={ a.get('selected') ? 'info-dark' : '' }>
                                                                            <td style={{ width: '20px' }}><input type="checkbox" style={{ marginTop: '6px' }} value={ a.get('selected') } onChange={ (e) => this.props.updateInputs(`responsable_ingreso.${b}.selected`, e.target.checked) } /></td>
                                                                            <td style={{ width: '43%' }}>
                                                                                <SelectorInput value={ a.get('fullname') ? a.get('fullname') : '' } onClick={ () => this.handleOpenSelectorAddResponsable(`responsable_ingreso.${b}`) } onReset={ () => this.props.updateInputs(`responsable_ingreso.${b}`, { selected: a.get('selected'), guid: a.get('guid') }) } />
                                                                            </td>
                                                                            <td style={{ width: '43%' }}><input type="text" className="form-control input-sm" value={ a.get('area') || '' } disabled /></td>
                                                                            <td style={{ width: '14%' }}><input type="text" className="form-control input-sm" value={ a.get('extension') || '' } disabled /></td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </Box>
                                        </div>
                                        <div className="col-md-6">
                                            <Box title={ `Responsables del recibo del servicio` } actions={ actionsAdicionarResponsable('responsable_recibo') } onModal>
                                                <div className="box-content" style={{ height: '81px', overflowX: 'hidden' }}>
                                                    <table className="table table-condensed">
                                                        <tbody>
                                                            {
                                                                creacionsolicitudservicioot.get('responsable_recibo').map((a, b) => {
                                                                    return (
                                                                        <tr key={ `tr3[${a.get('id')}]` } className={ a.get('selected') ? 'info-dark' : '' }>
                                                                            <td style={{ width: '20px' }}><input type="checkbox" style={{ marginTop: '6px' }} value={ a.get('selected') } onChange={ (e) => this.props.updateInputs(`responsable_recibo.${b}.selected`, e.target.checked) } /></td>
                                                                            <td style={{ width: '43%' }}>
                                                                                <SelectorInput value={ a.get('fullname') ? a.get('fullname') : '' } onClick={ () => this.handleOpenSelectorAddResponsable(`responsable_recibo.${b}`) } onReset={ () => this.props.updateInputs(`responsable_recibo.${b}`, { selected: a.get('selected'), guid: a.get('guid') }) } />
                                                                            </td>
                                                                            <td style={{ width: '43%' }}><input type="text" className="form-control input-sm" value={ a.get('area') || '' } disabled /></td>
                                                                            <td style={{ width: '14%' }}><input type="text" className="form-control input-sm" value={ a.get('extension') || '' } disabled /></td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </Box>
                                        </div>
                                    </div>                                
                                </BoxSection>


                                <div className="separator"></div>
                                <BoxSection title="Detalles servicios" actions={ actionsSectionDetallesServicios } >
                                    <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-tipo-moneda">
                                        <thead>
                                            <tr>
                                                <th style={{ maxWidth: '86%', padding:'0 10px' }}>Tipo de moneda:</th>
                                                <th style={{textAlign:'right'}}>
                                                    <div style ={{alignItems:'flex-end'}} className="btn-group" role="group" aria-label="Basic outlined example">
                                                        {
                                                            divisas && divisas.map((d,i) => {
                                                                return (
                                                                    <button key={`d[${i}]`} style={{borderRadius: '5px'}} onClick={() => this.handleOpenSelectorMoneda(d.get('CODIGO'))} type="button" className={ moneda == d.get('CODIGO') ? 'btn btn-primary' : 'btn btn-outline-primary' }>{ d.get('CODIGO') }</button>
                                                                );
                                                            })
                                                        }
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-solicitudes">
                                        <thead>
                                            <tr>
                                                <th width="20px">
                                                    <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={ e => this.props.toggleSelectAllSolicitudServicioItems(e.target.checked) } checked={ creacionsolicitudservicioot.get('servicios').filter(x => x.get('selected')).count() > 0 } />
                                                </th>
                                                <th style={{ width: '5%' }}>No.</th>
                                                <th style={{ width: '55%' }}>Descripción del servicio</th>
                                                <th style={{ width: '20%' }}>Valor del servicio sin IVA</th>
                                                <th style={{ width: '20%' }}>Valor total del servicio</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                (creacionsolicitudservicioot.get('servicios').count() > 0) ?
                                                    creacionsolicitudservicioot.get('servicios').map((x, n) => {
                                                        return (
                                                            <tr key={ x.get('id') ? x.get('id') : x.get('guid') } className={ x.get('selected') ? 'info' : '' }>
                                                                <td><input type="checkbox" style={{ verticalAlign: 'middle' }} checked={ x.get('selected') } onChange={ (e) => this.props.updateInputs(`servicios.${n}.selected`, e.target.checked) } /></td>
                                                                <td className='LinkToEdit' style={{ textAlign: 'right' }} onClick={ e => this.props.displayModalAddServicio(true, 'Modificación de items', 'edit', n) }>{ n + 1 }</td>
                                                                <td>{ x.get('descripcion') }</td>
                                                                <td style={{ textAlign: 'right' }}>{formatcoin(x.get('cotizado'),divisa.simbolo)}</td>
                                                                <td style={{ textAlign: 'right' }}>{formatcoin(x.get('cotizado_iva'),divisa.simbolo)}</td>
                                                            </tr>
                                                        )
                                                    })
                                                :
                                                    <tr>
                                                        <td colSpan={ 5 } style={{ textAlign: 'center' }}>Para crear los servicios haga click en el botón <span style={{ color: '#888' }}><FontAwesome name="plus-circle" /></span></td>
                                                    </tr>
                                            }
                                        </tbody>
                                    </table>
                                </BoxSection>


                                <div className="separator"></div>


                                <BoxSection title="Recursos">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label className="control-label">Ordenador del gasto</label>
                                                        <SelectorInput value={ creacionsolicitudservicioot.getIn(['ordenador_gasto', 'fullname']) || '' } onClick={ () => this.handleOpenSelector('ordenador_gasto') } onReset={ () => this.props.updateInputs('ordenador_gasto', null) } />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="control-label">Anticipo aprobado, %</label>
                                                        <input type="number" className="form-control input-sm" value={ creacionsolicitudservicioot.get('anticipo') } onChange={ e => this.props.updateInputs('anticipo', e.target.value) }/>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label className="control-label">Valor del anticipo</label>
                                                        <input type="text" className="form-control input-sm" value={formatcoin(((Number(creacionsolicitudservicioot.get('anticipo'))/100)*totalSevicios_sin_iva),divisa.simbolo)} disabled />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-8">
                                            <Box title="Distribución en centros de costo" actions={ actionsDistribucionCencos } onModal>
                                                <div className="box-content" style={{ height: '81px', overflowX: 'hidden' }}>
                                                    <table className="table table-condensed">
                                                        <tbody>
                                                            {
                                                                creacionsolicitudservicioot.get('cencos').map((x, n) => {
                                                                    return (
                                                                        <tr key={ `tr[${x.get('guid')}]` } className={ x.get('selected') ? 'info-dark' : '' }>
                                                                            <td style={{ width: '20px' }}><input type="checkbox" style={{ marginTop: '6px' }} checked={ x.getIn('selected') } onChange={ (e) => this.props.updateInputs(`cencos.${n}.selected`, e.target.checked) } /></td>
                                                                            <td style={{ width: '20px', verticalAlign: 'middle' }} ><span>{ n + 1 }</span></td>
                                                                            <td style={{ width: '55%' }}>
                                                                                <SelectorInput value={ x.getIn(['cenco', 'descripcion']) ? x.getIn(['cenco', 'descripcion']) : '' } onClick={ () => this.handleOpenSelectorAddCenco(`cencos.${n}.cenco`) } onReset={ () => this.props.updateInputs(`cencos.${n}.cenco`, null) } />
                                                                            </td>
                                                                            <td><input type="number" className="form-control input-sm" placeholder="Porcentaje" value={ x.get('porcentaje') } onChange={ (e) => this.props.updateInputs(`cencos.${n}.porcentaje`, e.target.value) } /></td>
                                                                            <td style={{ width: '20px', verticalAlign: 'middle' }}>%</td>
                                                                            <td><input type="text" className="form-control input-sm" value={ numeral(Number(x.get('porcentaje')) / 100 * totalSevicios).format('$0,0.00') } disabled /></td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </Box>
                                        </div>
                                    </div>
                                </BoxSection>

                                <div className="separator"></div>

                                <BoxSection title="Observaciones">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <textarea type="text" className="form-control input-sm" rows={4} value={ creacionsolicitudservicioot.get('observaciones') } onChange={ (e) => this.props.updateInputs('observaciones', e.target.value) } />
                                            </div>
                                        </div>
                                    </div>
                                </BoxSection>

                                <div className="separator"></div>

                                <AttachedFilesBox
                                    files={ creacionsolicitudservicioot.get('adjuntos') }
                                    removeFiles = { this.props.removeSolicitudServicioFiles }
                                    updateInputs = { this.props.updateInputs }
                                    obj={ creacionsolicitudservicioot }
                                    check={ 'solicitud' }
                                />


                            </div>
                        </div>
                    </Box>
                </div>
                <ModalAddServicio />
                <ModalAddFile
                    action={ () => this.props.addSolicitudServicioFile() }
                />


                <ModalSelectorFromList />
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        user: state.common.get('user'),        
        creacionsolicitudservicioot: state.creacionsolicitudservicioot,
        enums: state.common.get('enums').toJS(), 
        divisas: state.common.getIn(['parametros', 'DIVISAS'])
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
        showModalSelector: (title, fields, url, action, customFilter) => dispatch(showModalSelector(title, fields, url, action, customFilter)),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        displayModalAddServicio: (show, title, mode, index) => dispatch(displayModalAddServicio(show, title, mode, index)),
        removeSolicitudServicioItems: () => dispatch(removeSolicitudServicioItems()),
        toggleSelectAllSolicitudServicioItems: (checked) => dispatch(toggleSelectAllSolicitudServicioItems(checked)),
        displayModalAddFile: (show, title, mode, index) => dispatch(displayModalAddFile(show, title, mode, index)),
        toggleSelectAllSolicitudServicioFiles: (checked) => dispatch(toggleSelectAllSolicitudServicioFiles(checked)),
		uploadFile: (file) => dispatch(uploadFile(file)),
        createSolicitudServicio: () => dispatch(createSolicitudServicio()),
        removeSolicitudServicioResponsable: (path) => dispatch(removeSolicitudServicioResponsable(path)),
        addResponsable: (path) => dispatch(addResponsable(path)),
        addCencoSolicitudServicio: () => dispatch(addCencoSolicitudServicio()),
        removeCencosSolicitudServicio: () => dispatch(removeCencosSolicitudServicio()),
        addUsuarioResponsable: (path) => dispatch(addUsuarioResponsable(path)),
        removeSolicitudServicioFiles: () => dispatch(removeSolicitudServicioFiles()),
        initReducer: () => dispatch(initReducer()),
        addSolicitudServicioFile: (data) => dispatch(addSolicitudServicioFile(data)),
        getParameterByName: (nombre) => dispatch(getParameterByName(nombre)),
        enviarComentario: () => dispatch(enviarComentario()),
        eliminarComentario: (guid) => dispatch(eliminarComentario(guid)),
        editarComentario: (guid) => dispatch(editarComentario(guid))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreacionSolicitudServicioOT)


// WEBPACK FOOTER //
// ./src/containers/CreacionSolicitudServicioOT.jsx